<template>
    <div>
        <config-main-title>
            Bancos
        </config-main-title>

        <div class="row mb-3">
            <div class="col col-12 col-md-6">
                <az-input icon="fas fa-search" v-model="search" />
            </div>
            <div class="col col-12 col-md-3 d-flex flex-column">
                <div class="btn-group mb-1" role="group" aria-label="Basic example">
                    <button type="button" class="btn" :class="viewMode == 'A' ? 'btn-secondary' : 'btn-outline-secondary'" 
                    @click="viewMode = 'A'">
                        Ativos
                    </button>
                    <button type="button" class="btn" :class="viewMode == 'T' ? 'btn-secondary' : 'btn-outline-secondary'" 
                    @click="viewMode = 'T'">
                        Todos
                    </button>
                </div>
            </div>
            <div class="col col-12 col-md-3 d-flex flex-column">
                <button type="button" class="btn btn-outline-success" @click="incluirConta ()">
                    Incluir
                </button>
            </div>
        </div>

        <div v-if="dados && lista.length">

            <div class="list-group mb-3 az-anime-surgir mb-3">
                <li class="list-group-item" v-for="(dado, id) in lista" :key="id">
                    <div class="d-flex justify-content-between">
                        <span class="h5 card-link mb-0 mr-3">
                            <a href="#" @click.prevent="editar (dado)">
                                {{ dado.search }}
                            </a>
                        </span>
                        <span>
                            <div class="custom-control custom-switch" v-if="viewMode == 'T'">
                                <input type="checkbox" class="custom-control-input" 
                                    :id="'categoria-' + id " 
                                    v-model="dado.fl_ativo"
                                    @change="toggle(dado)">
                                <label class="custom-control-label" :for="'categoria-' + id "></label>
                            </div>
                        </span>
                    </div>
                </li>
            </div>

            <pre v-if="1 == 0">{{ dados }}</pre>
        </div>

        <div v-else>
            <az-empty-state msg="Nenhum conta registrada." />
        </div>

        <!-- Modal -->
        <div class="modal fade" id="contaModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content" v-if="item">
                    <div class="modal-header">
                        <h5 class="modal-title">Banco</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col col-12 col-md-9">
                                <az-input 
                                    label="Nome do Banco"
                                    required 
                                    v-model="item.st_banco" />
                            </div>
                            <div class="col col-12 col-md-3">
                                <az-input 
                                    label="Código"
                                    type="number"
                                    maxlength="3"
                                    v-model="item.in_codigo" />
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <az-audit-log-button v-if="item.id_banco" model="banco" :id="item.id_banco" />
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="atualizar ()">{{ item.id_banco ? 'Atualizar' : 'Incluir' }}</az-submit>
                    </div>
                </div>
            </div>
        </div>
        
    </div>
</template>

<script>
import $ from 'jquery';
import _ from 'lodash';
import ConfigMainTitle from '../../cadastros/shared/ConfigMainTitle.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import AzInput from '../../shared/forms/AzInput.vue';
import AzSubmit from '../../util/AzSubmit.vue';
import AzAuditLogButton from '../../util/AzAuditLogButton.vue';

export default {
    data () { 
        return { 
            dados: null, 
            em_edicao: false, 
            item: null, 
            validate: false,
            search: "", 
            viewMode: 'A'
        }
    },

    computed: { 
        lista: function () { 
            let pesquisar = this.search.trim();
            let parts = pesquisar.replace(' ','.*');
            let match = parts;
            let reg = new RegExp(match, 'i');

            return this.dados.filter (item => { 
                return ( item.fl_ativo || this.viewMode == 'T' ) && 
                    ( !this.search || reg.test(JSON.stringify(item)) )
            });
        }
    },

    components: { 
        ConfigMainTitle,
        AzEmptyState,
        AzInput,
        AzSubmit, 
        AzAuditLogButton,
    },

    methods: { 
        atualizar () { 

            this.$util.atualizar (this, { 
                service: 'bancos',
                dados: this.item, 
                modal: 'contaModal',
                reload: true, 
            });

        },

        editar (item) { 
            this.item = null;

            this.$nextTick (() => { 
                this.item = _.cloneDeep(item);

                if ( !this.item.dados_bancarios ) { 
                    this.item.dados_bancarios = {
                        id_dados_bancarios: null, 
                        id_banco: null, 
                        in_agencia: null, 
                        in_conta: null, 
                        ch_digito_conta: null, 
                        st_observacoes: null, 
                    };
                }

                $('#contaModal').modal('show');
            });
        },

        toggle (item) { 

            this.$util.toggle (this, { 
                service: 'bancos',
                dados: item, 
            });

        },

        incluirConta () { 
            this.item = null;

            this.$nextTick (() => { 
                this.item = {
                    id_conta: null, 
                    st_conta: "", 
                    dados_bancarios: {
                        id_dados_bancarios: null, 
                        id_banco: null, 
                        in_agencia: null, 
                        in_conta: null, 
                        ch_digito_conta: null, 
                        st_observacoes: null, 
                    }, 
                };
                $('#contaModal').modal('show');
            });
        },

        load () { 
            this.$util.load(this, { 
                service: 'bancos',
                parms: { 
                    cadastro: true, 
                }
            });
        },

    },

    mounted () { 
        this.load ();

        this.breadcrumb = [
                { name: "Configurações", path: "/cadastros"},
                { name: "Bancos", path: "" },
            ];

        this.$store.commit('setBreadcrumb', this.breadcrumb);
    }
}
</script>